export default {
    addressList: (data) => window.axios.get('customer/shipping-address', data),
    deleteAddress: (id) => window.axios.delete(`customer/shipping-address/${id}`),
    addAddress: (data) => window.axios.post('customer/shipping-address', data),
    updateAddress: (data, address_id) => window.axios.put(`customer/shipping-address/${address_id}`, data),
    primaryAddress: (data) => window.axios.get('customer/shipping-address/primary', data),
    setPrimaryAddress: (data) => window.axios.post('customer/shipping-address/set-primary', data),
    checkDeliveryZone: (data, latitude, longitude) => window.axios.get(`check-delivery-zone?latitude=${latitude}&longitude=${longitude}`, data),

    getUserAddress: (data) => window.axios.post('get_user_address', data)

}